import View               from '@widesk-ui/components/View';
import theme              from 'antd/lib/theme';
import AntdBreadcrumb     from 'antd/lib/breadcrumb';
import { matchRoutes }    from 'react-router-dom';
import { useMatches }     from 'react-router-dom';
import { HomeOutlined }   from '@ant-design/icons';
import breadcrumbBarStore from '@widesk-ui/stores/breadcrumbBarStore';
import { observer }       from 'mobx-react-lite';

const { useToken } = theme;

const BreadcrumbBar = observer(() => {
	if (!breadcrumbBarStore.enabled) return null;

	return <BreadcrumbBarContent />;
});

export const BreadcrumbBarContent = observer(() => {
	const { token } = useToken();
	const matches = useMatches();

	const crumbs = matches
		.filter((match) => Boolean((match.handle as any)?.crumb))
		.map((match) => (match.handle as any)?.crumb(match.data));

	const isHome = matches.every(m => m.pathname === '/');

	const routes = [{
		href: isHome ? undefined : '/',
		title: isHome ? ' Accueil' : <HomeOutlined />,
	}];

	const pathname = matches.at(-1)?.pathname;
	const svPath = pathname?.replace(/\/[^/]+$/, '/split') || '';

	if (
		!pathname?.includes('/split')
		&& svPath.includes('/split')
		&& matchRoutes(breadcrumbBarStore.routes, svPath)?.length
	) {
		routes.push({ href: svPath, title: 'Liste' });
	}

	routes.push(...crumbs.map((title) => ({ title, href: undefined })));

	if (!isHome && !crumbs.length && !breadcrumbBarStore.rightComponent) {
		return null;
	}

	document.title = crumbs.at(-1) || `Accueil`;

	return (
		<View
			bg={token.colorBgContainer}
			minHeight={50}
			centerV
			paddingH={token.marginLG}
			separatorB
			row
			spread
		>
			<View centerV flex gapH="xxs" row>
				<AntdBreadcrumb items={routes} />
				{breadcrumbBarStore.breadcrumbSuffix && (`- ${ breadcrumbBarStore.breadcrumbSuffix}`)}
			</View>

			{!!breadcrumbBarStore.rightComponent && breadcrumbBarStore.rightComponent()}
		</View>
	);
});

export default BreadcrumbBar;
